export default __webpack_public_path__ + "img/main.default.9a0b603e.png";